import { render, staticRenderFns } from "./StudentSubjectsBatch.vue?vue&type=template&id=02d72dd4&scoped=true"
import script from "./StudentSubjectsBatch.vue?vue&type=script&lang=js"
export * from "./StudentSubjectsBatch.vue?vue&type=script&lang=js"
import style0 from "./StudentSubjectsBatch.vue?vue&type=style&index=0&id=02d72dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d72dd4",
  null
  
)

export default component.exports